import * as React from 'react';
import { connect } from 'react-redux';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { prop } from '../../../utilities';

const grow = keyframes`
  0% { width: 0; }
  50% { width: 65%; }
  100% { width: 90%; }
`;

const Bar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: ${rem(3)};
  background: ${({ theme }) => theme.color.primary};
  z-index: 10000;
  pointer-events: none;
  animation: ${grow} 4s ease-out forwards;
`;

interface Props {
  loading: boolean;
}

class NavigationProgress extends React.PureComponent<Props> {
  public render() {
    if (!this.props.loading) {
      return null;
    }
    return <Bar />;
  }
}

const mapStateToProps = (state) => ({
  loading: prop(state, 'general.navigation.loading', false),
});

export default connect(mapStateToProps)(NavigationProgress);
